import { createContext, useContext } from "react";
import type { PageProps } from "gatsby";

interface ContextProps {
    location?: PageProps["location"];
}

const LocationContext = createContext<ContextProps | undefined>(undefined);

export const useLocation = () => {
    const context = useContext(LocationContext);
    return context?.location;
};

export default LocationContext;
